var map = {
	"./GCI.png": 52,
	"./HitATune.png": 53,
	"./OppCal.PNG": 54,
	"./RGB.PNG": 55,
	"./Sudoku.PNG": 56,
	"./background.jpg": 57,
	"./profile.PNG": 33
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;